// eslint-disable-next-line import/no-unresolved,import/extensions
import User from '@/user';

export default () => {
  // TODO: Logica usando data-partner en el modulo
  const modulePartners = document.getElementById('info_partners');
  const moduleNoPartners = document.getElementById('info_nopartners');
  const isPreview = document.querySelector('[data-partner]');

  if ((User.isPartner && !isPreview) || (isPreview && isPreview.dataset.partner === '1')) {
    if (modulePartners) {
      modulePartners.classList.remove('hidden');
    }
    if (moduleNoPartners) {
      moduleNoPartners.classList.add('hidden');
    }
  }
};
